import React from 'react';
import { Button } from './ui/button';

export const Header = () => {
  return (
    <header className="fixed top-0 w-full z-50 bg-white/95 backdrop-blur-sm border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <div className="flex items-center space-x-2">
            <div className="w-8 h-8 bg-slate-900 rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-sm">AI</span>
            </div>
            <span className="text-xl font-bold text-gray-900">Agents.audio</span>
          </div>
          
          <nav className="hidden md:flex space-x-8">
            <a href="#features" className="text-gray-600 hover:text-slate-900 transition-colors font-medium">Features</a>
            <a href="#demo" className="text-gray-600 hover:text-slate-900 transition-colors font-medium">Demo</a>
            <a href="#testimonials" className="text-gray-600 hover:text-slate-900 transition-colors font-medium">Testimonials</a>
            <a href="#integrations" className="text-gray-600 hover:text-slate-900 transition-colors font-medium">Integrations</a>
          </nav>
          
          <div className="flex items-center space-x-4">
            
            <Button
              className="bg-gradient-to-r from-emerald-500 to-green-600 hover:from-emerald-600 hover:to-green-700 text-white font-medium shadow-lg hover:shadow-xl transition-all duration-200"
              onClick={() => window.open('https://calendly.com/rajat-agents/30min', '_blank')}
            >
              Book Demo
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
};